import { ConcreteEncodable } from "./ConcreteEncodable";

import { OpsIntEventImplEncoder } from "../../encoder/OpsIntEventImplEncoder";

import * as CubiqTS from "../../index";
import { OpsIntEvent } from "../OpsIntEvent";

export class OpsIntEventImpl extends ConcreteEncodable implements OpsIntEvent {
  public static enType: string = "com.bcdfx.model.OpsIntEventImpl";

  /*FID=1*/
  public info: CubiqTS.OpsExcInfo | null = null;
  /*FID=2*/
  public eventId: CubiqTS.Long | null = null;
  /*FID=3*/
  public opsErrors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OpsIntEventImplEncoder.Instance;
    this.setEncodableType(OpsIntEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OpsIntEventImpl[" +
      "info=" +
      this.info +
      "eventId=" +
      this.eventId +
      "opsErrors=" +
      this.opsErrors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
